import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Subject } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { SpinnerVisibilityService } from "ng-http-loader";

@Injectable()

export class AuthService {

  url: any = environment.API_URL;
  currentUser: any = localStorage.getItem("currentUser")

  constructor(
    private http: HttpClient,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private spinner: SpinnerVisibilityService
  ) { }

  public get currentUserValue() {
    let data: any = localStorage.getItem('currentUser');
    let obj: any = {};
    if (data !== 'undefined')
      return JSON.parse(localStorage.getItem('currentUser') || '{}');
    return false;
  }


  public get basicAuthentication() {
    let data = {
      userName: '3xaUser!@3#',
      password: '9raPass@3!)#@done'
    }
    return data;
  }

  login(user: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + window.btoa(this.basicAuthentication.userName + ':' + this.basicAuthentication.password)
      })
    };
    return this.http.post<any>(this.url + 'user/login', user, httpOptions);
  }

  logout(data: any) {
    return this.http.post(this.url + 'user/logout', data);
  }


  signup(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + window.btoa(this.basicAuthentication.userName + ':' + this.basicAuthentication.password)
      })
    };
    return this.http.post(this.url + 'user/signup', data, httpOptions);
  }

  forgetPassword(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + window.btoa(this.basicAuthentication.userName + ':' + this.basicAuthentication.password)
      })
    };
    return this.http.post(this.url + 'user/forgot-password', data, httpOptions);
  }

  getAuthStatus() {
    var token = localStorage.getItem("currentUser")
    console.log(token)
    if (token != null) {
      console.log("hell")
      return true;
    } else {
      console.log("hi")
      return false
    }
  }

  checkToken() {
    this.currentUser = JSON.parse(this.currentUser);
    if (this.currentUser === null) {
      this.route.navigate(['/auth']);
    }
  }

  logoutFN() {
    localStorage.removeItem("currentUser");

    this.spinner.show();
    // this.route.navigate(['/'])
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      window.location.href = "/"

    });
  }



}
